import { apolloClient } from '@/plugins/apollo';
import { GetCurrentResearcher } from '@/graphql';

export const superAdminGuard = async (to, from, next) => {
  try {
    const { data } = await apolloClient.query({
      query: GetCurrentResearcher,
      fetchPolicy: 'cache-first',
    });

    if (
      data &&
      data.currentResearcher &&
      data.currentResearcher.isSuperAdmin
    ) {
      return next();
    }
  } catch (e) {
    // If the query fails (e.g. network error), deny access
  }

  return next('/');
};
